<template>
    <section class="bg-[#F5F5F5] py-20 sm:py-28" id="testimonials">
        <div class="mx-auto max-w-7xl px-6 lg:px-8">
            <div class="mb-14">
                <span class="text-xs font-semibold uppercase tracking-widest text-[#A07830]">Testimonials</span>
                <h2 class="mt-3 text-3xl sm:text-4xl font-extrabold text-[#17364a] tracking-tight">
                    What Our Students Say
                </h2>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div
                    v-for="testimonial in testimonials"
                    :key="testimonial.id"
                    class="bg-white border border-[#E5E5E5] p-7 flex flex-col gap-4"
                >
                    <!-- Stars -->
                    <div class="flex items-center gap-0.5">
                        <svg v-for="n in 5" :key="n" class="h-4 w-4 text-[#A07830]" fill="currentColor" viewBox="0 0 20 20">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                        </svg>
                    </div>
                    <!-- Quote -->
                    <p class="text-sm text-gray-600 leading-relaxed flex-1">
                        <span class="text-2xl font-bold text-[#A07830] leading-none mr-1">"</span>{{ testimonial.testimonial }}<span class="text-2xl font-bold text-[#A07830] leading-none ml-1">"</span>
                    </p>
                    <!-- Author -->
                    <div class="flex items-center gap-3 pt-4 border-t border-[#F5F5F5]">
                        <img src="/images/default-avatar.png" alt="" class="h-9 w-9 rounded-full object-cover bg-gray-100" />
                        <div>
                            <div class="text-sm font-bold text-[#17364a]">{{ testimonial.name }}</div>
                            <div class="text-xs text-gray-400">Student</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';

const testimonials = ref([]);

onMounted(async () => {
    try {
        const response = await axios.get('/api/testimonials');
        testimonials.value = response.data.data;
    } catch {}
});
</script>
